import React from "react"
import { Tooltip } from "antd"

interface PageHeaderProps {
  title: React.ReactNode
  /** Tooltip text for the title; defaults to the title when it is a string. */
  titleText?: string
  /** View switch or selector, right after the title. */
  left?: React.ReactNode
  /** Search, secondary controls, then the one solid action, at the far end. */
  right?: React.ReactNode
}

/**
 * The header row of a page or toolbar: the title on one line (truncated, with
 * a tooltip), the view switch after it and the actions pushed to the end. The
 * row never wraps; the title is the part that gives way when space runs out.
 */
const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  titleText,
  left,
  right,
}) => {
  const tooltip = titleText ?? (typeof title === "string" ? title : undefined)

  return (
    <div className="dq-page-header flex flex-nowrap items-center gap-3 min-w-0">
      <Tooltip title={tooltip} placement="bottomLeft">
        <h1 className="m-0 min-w-0 truncate whitespace-nowrap text-xl font-semibold">
          {title}
        </h1>
      </Tooltip>
      {left && <div className="flex flex-none items-center gap-2">{left}</div>}
      {right && (
        <div className="ml-auto flex flex-none items-center gap-2">{right}</div>
      )}
    </div>
  )
}

export default PageHeader
